import DOMPurify from "dompurify";

const allowedStyles = [
  "font-weight",
  "text-decoration",
  "font-style",
  "text-align",
];

// Filter inline styles
DOMPurify.addHook("uponSanitizeAttribute", (node, data) => {
  if (data.attrName === "style") {
    const filteredStyles = data.attrValue
      .split(";")
      .map((style) => style.trim())
      .filter((style) => {
        const [key] = style.split(":").map((s) => s.trim());
        return allowedStyles.includes(key);
      })
      .join("; ");

    if (filteredStyles) {
      data.attrValue = filteredStyles;
    } else {
      data.keepAttr = false;
    }
  }
});

const processHtmlForEmail = (input: string): string => {
  let html = input;

  // Fix broken newlines
  html = html
    // Normalize escaped newlines first
    .replace(/\\n/g, "\n")
    // Preserve paragraph breaks (2+ newlines)
    .replace(/\n{2,}/g, "___PARA___")
    // Replace single newlines (inside sentences) with space
    .replace(/\n/g, " ")
    // Restore paragraph breaks
    .replace(/___PARA___/g, "\n\n");

  // Normalize problematic characters
  html = html
    .replace(/₹/g, "&#8377;")
    .replace(/–/g, "&ndash;")
    .replace(/—/g, "&mdash;")
    .replace(/“/g, "&ldquo;")
    .replace(/”/g, "&rdquo;")
    .replace(/‘/g, "&lsquo;")
    .replace(/’/g, "&rsquo;")
    .replace(/'/g, "&apos;");

  // Replace newlines and tabs (after fixing them)
  html = html
    .replace(/\r\n|\r|\n/g, "___LINEBREAK___")
    .replace(/\\t|\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;");

  // Remove invalid <client> tags
  html = html.replace(/<\/?client[^>]*>/g, "");

  // Remove consecutive <br> and normalize spaces
  html = html.replace(/(<br\s*\/?>\s*){2,}/gi, "<br/>").replace(/\s{2,}/g, " ");

  // Sanitize HTML
  html = DOMPurify.sanitize(html, {
    FORBID_TAGS: ["input", "iframe", "button", "a", "img", "svg"],
    ALLOWED_ATTR: ["style"],
    FORBID_ATTR: ["class", "className"],
  });

  // Cleanup unwanted <br/>
  html = html.replace(/___LINEBREAK___/g, "<br/>")
  html = html.replace(/(<p[^>]*>)<br\s*\/?>/gi, "$1");
  html = html.replace(/<br\s*\/?>(<\/li>|<\/ul>)/gi, "$1");

  // Convert non-ASCII chars to entities (emojis preserved)
  html = Array.from(html)
    .map((c) => {
      const code = c.codePointAt(0)!;
      return code > 127 ? `&#${code};` : c;
    })
    .join("");

  // Remove empty tags but preserve inner whitespace
  html = html.replace(/<(\w+)[^>]*>((?:\s|&nbsp;|<br\s*\/?>)*)<\/\1>/gi, "$2");

  // Remove leading <br/> or whitespace
  html = html.replace(/^(\s|<br\s*\/?>)+/, "");

  return html;
};

export default processHtmlForEmail;
